import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { FREE, PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { getMerchCardsToShow } from '../../constants/merchCards/MerchCardsToShow';
import { isProGWP2023EligibleSelector } from '../../selectors/PromotionSelectors';
import { ShadowCardGrid, ShadowColumn, ShadowSuiteStarterCardGrid, StyledCardGrid, StyledCardGridWrapper, SuiteStarterCardGrid, SuiteStarterCardGridWrapper } from './MerchCardSharedComponents';
import SuiteFreeTile from './SuiteFreeTile';
import { SuiteTile } from './SuiteTile';
import { Section } from '../common/SharedComponents';
export const SuiteTiles = ({
  selectedTab,
  isFreeToStarter
}) => {
  const productLevelsToShow = getMerchCardsToShow({
    tab: selectedTab,
    isFreeToStarter
  });
  const isProGWP = useSelector(isProGWP2023EligibleSelector);
  const GridComponent = isFreeToStarter ? SuiteStarterCardGrid : StyledCardGrid;
  const ShadowGridComponent = isFreeToStarter ? ShadowSuiteStarterCardGrid : ShadowCardGrid;
  const GridWrapper = isFreeToStarter ? SuiteStarterCardGridWrapper : StyledCardGridWrapper;
  const suiteCardComponents = productLevelsToShow.map((productLevel, index) => {
    const commonStyles = {
      msGridColumn: index + 1,
      // IE
      gridColumnStart: index + 1,
      paddingLeft: 28,
      paddingRight: 28
    };
    const disclaimer = productLevel === PROFESSIONAL && isProGWP ? 'pricingPage.promotions.proGWPDisclaimer' : undefined;

    if (FREE === productLevel) {
      return /*#__PURE__*/_jsx(SuiteFreeTile, {
        commonStyles: commonStyles,
        isFreeToStarter: isFreeToStarter
      }, productLevel);
    }

    return /*#__PURE__*/_jsx(SuiteTile, {
      productLevel: productLevel,
      commonStyles: commonStyles,
      disclaimer: disclaimer,
      isFreeToStarter: isFreeToStarter
    }, productLevel);
  });
  const shadowColumns = productLevelsToShow.map(productLevel => /*#__PURE__*/_jsx(ShadowColumn, {
    isFreeToStarter: isFreeToStarter
  }, `${productLevel}-shadow`));
  return /*#__PURE__*/_jsx(Section, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx("div", {
      className: "flex-column align-center justify-center",
      children: /*#__PURE__*/_jsxs(GridWrapper, {
        columns: productLevelsToShow.length,
        children: [/*#__PURE__*/_jsx(GridComponent, {
          columns: productLevelsToShow.length,
          children: suiteCardComponents
        }), /*#__PURE__*/_jsx(ShadowGridComponent // @ts-expect-error columns prop only conditionally expected
        , {
          columns: productLevelsToShow.length,
          "aria-hidden": "true",
          isFreeToStarter: isFreeToStarter,
          children: shadowColumns
        })]
      })
    })
  });
};